import React, {useMemo} from "react";
import DOMPurify from "dompurify";
import {Box} from "@mui/material";
import {parseDescriptionFromApi} from "../../utils/richTextUtils";

const RichTextHtml = ({html, sx}) => {
    const sanitizedHtml = useMemo(() => {
        const parsed = parseDescriptionFromApi(html);
        if (!parsed) {
            return "";
        }
        return DOMPurify.sanitize(parsed, {
            USE_PROFILES: {html: true},
        });
    }, [html]);

    if (!sanitizedHtml) {
        return null;
    }

    return (
        <Box
            className="rich-text-html"
            sx={{
                fontFamily: "Roboto, sans-serif",
                fontSize: "1rem",
                lineHeight: 1.5,
                "& p": {margin: "0 0 0.75em"},
                "& p:last-child": {marginBottom: 0},
                "& ul, & ol": {margin: "0 0 0.75em", paddingLeft: "1.5em"},
                "& h1, & h2, & h3": {margin: "0 0 0.5em", fontWeight: 600},
                "& a": {color: "primary.main"},
                ...sx,
            }}
            dangerouslySetInnerHTML={{__html: sanitizedHtml}}
        />
    );
};

export default RichTextHtml;
